import { useContext, useEffect, useRef } from 'react';
import { GlobalContext } from "../contexts/globalContext"
import io from "socket.io-client"

const SocketManagerLocal = ({ onGetMac }) => {
    const {
        localSocketRef
    } = useContext(GlobalContext);

    useEffect(() => {
        console.log("SocketManager")
        localSocketRef.current = io.connect("http://localhost:6789", {
            reconnect: true,
            rejectUnauthorized: true
        })

        localSocketRef.current.on('connect', function () {
            localSocketRef.current.emit("systemInfo:getMac", (mac) => {
                console.log("mac: ", mac)
                if (mac) {
                    //onGetMac("b0:25:aa:70:4e:c1")
                    onGetMac(mac)
                }
            });
        });

        return () => {
            localSocketRef.current.disconnect()
            localSocketRef.current = null
        }
    }, [])

    return (
        <> </>
    );
}

export default SocketManagerLocal;